import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import listViewFormattingRulesHydrateJqlQueryParameters from '@atlassian/jira-relay/src/__generated__/list_hydrateJql_Query.graphql';
import listViewFormattingRulesQueryParameters from '@atlassian/jira-relay/src/__generated__/list_RuleList_Query.graphql';

export const conditionalFormattingSidebarEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-conditional-formatting-nin-sidebar" */ './index.tsx'),
	),
	getPreloadProps: ({
		projectKey,
		cloudId,
		hydrateJql,
	}: {
		projectKey: string;
		cloudId: string;
		hydrateJql: string;
	}) => ({
		queries: {
			listViewFormattingRulesQuery: {
				parameters: listViewFormattingRulesQueryParameters,
				variables: {
					projectKey,
					cloudId,
					first: 20,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
			listViewFormattingRulesHydrateJqlQuery: {
				parameters: listViewFormattingRulesHydrateJqlQueryParameters,
				variables: {
					cloudId,
					jql: hydrateJql,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
